module.exports = __webpack_public_path__ + "img/valley_oak_636d_list.5db29060.jpg";